import { Component, OnInit, OnChanges, Input, Output, EventEmitter, input } from '@angular/core';
import { DataProcessingService } from '@frontend/common';

import { Image } from '@frontend/core';
import { LinksService } from '../links.service';


@Component({
  selector: 'multisite-link-type-eight',
  templateUrl: './link-type-eight.component.html',
  styleUrls: ['./link-type-eight.component.scss'],

  standalone: false,
})
export class LinkTypeEightComponent implements OnInit, OnChanges {
  // Link with a clear Call To Action (CTA) and a click event emitter (not just plain URLs)

  
  @Input() imageTransformations : string; // 'w_275,ar_16:9/'
  @Input() titleText : string;
  @Input() titleTextTranslation : string; // not in use yet
  @Input() description : string; // optional
  @Input() imageUrl : string; // if no Image object
  @Input() url : string; // target page
  image = input<Image>();
  @Input() descriptionTruncateLength : number = 110;
  @Input() cta_label : string; // Custom text
  @Input() cta_type : string; // translation key
  // @Input() cta_text : string; // another fallback, just manual text
  @Output() linkClicked = new EventEmitter<Event>();


  constructor(
    private dataProcessingService : DataProcessingService,
  ) { }

  ngOnInit(): void {
    
  }

  doLinkClick (event : Event){
    if (this.url){
      window.location.href = this.url;
    }
    this.linkClicked.emit(event);
  }

  ngOnChanges(changesObject): void {
    if (changesObject?.description?.currentValue?.length){
      if (changesObject.description.currentValue.length > this.descriptionTruncateLength){
        this.description = this.truncateText(changesObject.description.currentValue,this.descriptionTruncateLength-10);
      };
    }
  }

  truncateText(sourceText : string, length : number){
    return this.dataProcessingService.truncateText(sourceText, length);
  }

}
